module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAiCAYAAAB4BHhVAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAABKADAAQAAAABAAAAIgAAAACL7SSmAAAANklEQVQoFWNggID/QAqEGZggfAQ5KoAICxBr6IQHqrtx8TyBEo+hGMQGc2DJ4TGGb0EqULQAAOjVCqsxuytWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/seckillSign.png
// module id = wI5b
// module chunks = 0